import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Index.module.css';

const SuccessState = () => {
    const navigate = useNavigate();

    return (
        <div className={styles.pageContainer}>
            <div className={styles.successContainer}>
                <div className={styles.successCard}>
                    <div className={styles.successIconWrapper}>
                        <svg className={styles.successIcon} viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                    </div>
                    <h2 className={styles.successTitle}>Thank You!</h2>
                    <p className={styles.successText}>
                        Your response has been successfully submitted. We appreciate your participation
                        in this important study.
                    </p>
                    <button onClick={() => navigate('/')} className={styles.homeButton}>
                        Return to Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SuccessState;